export class ApplicationPrepaidsApiV2 {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanPrepaids({ loanId }) {
    return this.#http.get(`/loan/${loanId}/prepaid-loan-fees/v2`);
  }

  async editLoanPrepaids({ loanId, withLoanOptionId, ...body }) {
    return this.#http.put(`/loan/${loanId}/prepaid-loan-fees/v2`, body, {
      params: { withLoanOptionId },
    });
  }
}
